import { NavLink } from "react-router-dom";
import Badge from "../common/Badge";
import { useAuth } from "../../contexts/AuthContext";
import uocLogo from "../../assets/uoc-logo.png";

const standardNav = [
  { to: "/dashboard", label: "Dashboard" },
  { to: "/patients", label: "Add Patient" },
  { to: "/request-access", label: "Request Access" },
];

const adminNav = [
  { to: "/dashboard", label: "Dashboard" },
  { to: "/patients", label: "Add Patient" },
  { to: "/admin", label: "Admin Panel" },
  { to: "/admin/users", label: "Users" },
  { to: "/admin/audit-logs", label: "Audit Logs" },
];

export default function Sidebar({ pendingCount = 0 }) {
  const { profile, signOutUser } = useAuth();
  const isAdmin = profile?.role === "admin";
  const nav = isAdmin ? adminNav : standardNav;

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <span>MedVault</span>
        <img src={uocLogo} alt="University Orthopedic Care logo" className="sidebar-logo-image" />
      </div>
      <nav className="sidebar-nav">
        {nav.map((item) => (
          <NavLink key={item.to} to={item.to} className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""}`}>
            <span className="sidebar-link-label">{item.label}</span>
            {item.to === "/admin/users" && pendingCount > 0 ? <span style={{ marginLeft: 8 }}>●</span> : null}
          </NavLink>
        ))}
      </nav>
      <div className="sidebar-footer">
        <div className="sidebar-footer-text" style={{ marginBottom: 8 }}>
          <div className="sidebar-footer-name">{profile?.displayName || "User"}</div>
          <Badge tone={isAdmin ? "admin" : "standard"}>{profile?.role || "standard"}</Badge>
        </div>
        <button type="button" className="btn btn-secondary full-width sidebar-footer-logout" onClick={signOutUser}>
          Logout
        </button>
      </div>
    </aside>
  );
}
